import type { ErrorEvent } from '@sentry/nextjs';

/**
 * Fehler, deren Stacktrace keinen einzigen Frame aus unseren Bundles enthält, stammen aus fremdem
 * Code: Tag-Manager-Container und Tracking-Skripte der Kunden (STELLENPORTAL-38, -3P), von
 * Chrome iOS oder In-App-Browsern eingeschleuste Skripte (STELLENPORTAL-3B, -49, -4J) und
 * Extensions. Wir können sie weder beheben noch verhindern.
 *
 * Events ohne Stacktrace bleiben erhalten, weil sie sich nicht zuordnen lassen.
 */
const isOwnFrame = (filename: string | undefined): boolean => Boolean(filename?.includes('/_next/'));

export const isThirdPartyError = (event: ErrorEvent): boolean => {
  const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? [];

  return frames.length > 0 && !frames.some((frame) => isOwnFrame(frame.filename));
};

export const dropThirdPartyErrors = (event: ErrorEvent): ErrorEvent | null => (isThirdPartyError(event) ? null : event);
